import EDPMedia from 'components/Content/Happening/HappeningEDP/EDPInfo/EDPMedia/EDPMedia';

export default EDPMedia;
